export const GET_FACILITY_PAGE_ACTION_NAME = "facilities/getFacilityPage";
export const GET_UNIT_ACTION_NAME = "units/getUnit";

export const GET_FACILITY_PAGE_FULFILLED = `${GET_FACILITY_PAGE_ACTION_NAME}/fulfilled`;
export const GET_UNIT_FULFILLED = `${GET_UNIT_ACTION_NAME}/fulfilled`;
